module.exports = __webpack_public_path__ + "img/pdf.3780a78e.svg";